import Constants from '../../../app/utils/constants'
import Button from '../../atoms/Button/Button'
import ArrowLine from '../../../assets/images/icons/arrowline.svg'
import Light from '../../../assets/images/homepage/light.svg'
import { useNavigate } from 'react-router-dom'

const ReadyToBuild = () => {
  const { readyToBuildSection } = Constants
  const navigate = useNavigate()

  return (
    <div className="px-4 md:px-6 lg:px-10 xl:px-30 mb-16">

      <div className="relative overflow-hidden w-full h-[480px] md:h-[450px] lg:h-[620px] rounded-[40px] border-2 border-purple/10 bg-[#0a061b]/10 px-0 md:px-8 lg:px-5 xl:px-5 2xl:px-20 pt-6 md:pt-8 lg:pt-10">

        {/* BG GLOW */}
        <div className="absolute bottom-0 left-0 w-full h-[50%] bg-gradient-to-t from-[#201645]/40 via-[#744DFF]/10 to-transparent blur-1xl" />

        <div className="relative z-10 h-full flex items-start">

          {/* LEFT CONTENT */}
          <div className="text-left ml-5 relative z-20">

            <h3 className="font-rajdhani w-full text-xl md:text-3xl lg:text-5xl xl:text-6xl font-semibold text-white leading-tight">
              {readyToBuildSection.header}
            </h3>

            <p className="mt-4 font-gilroy font-[400px] text-[#c4c0da] text-base md:text-xl lg:text-3xl max-w-4xl leading-relaxed">
              {readyToBuildSection.description}
            </p>

            <div className="flex flex-col gap-4 font-rajdhani font-semibold">

              <div className="flex mt-5 items-end md:h-[120px]">

                <Button
                  className="bg-purple w-full md:w-[250px] lg:w-[350px] text-white p-2 px-6 md:p-5 md:px-8 text-lg md:text-xl lg:text-2xl"
                  onClick={() => navigate('/contactus')}
                >
                  {readyToBuildSection.primaryButtonText}
                </Button>

                <img
                  src={ArrowLine}
                  alt="arrow line"
                  onClick={() => navigate('/contactus')}
                  className="hidden md:block w-[100px] lg:w-[130px] h-auto object-contain"
                />

              </div>

            </div>
          </div>

          {/* LIGHT IMAGE */}
          <div
            className="
              absolute bottom-0
              left-1/2 -translate-x-1/2
              md:left-auto md:translate-x-0 md:right-0
              lg:right-20
              flex justify-center
            "
          >
            <img
              src={Light}
              alt="Ready to build"
              className="
                w-[180px]
                sm:w-[220px]
                md:w-[220px]
                lg:w-[270px]
                xl:w-[350px]
                2xl:w-[480px]
                h-auto
                object-contain
              "
            />
          </div>

        </div>
      </div>
    </div>
  )
}

export default ReadyToBuild